import React from "react"
import TopTitle from "@components/TopTitle"
import Wrapper from "@components/Wrapper"
import styles from "./SectionOne.module.scss"
import SolutionVideo from "./DashboardVid.mp4";
import RiskGraphic from "./RiskFree.png";
import HelpGraphic from "./HowWeHelp.png";
import { OutboundLink } from '@assertiv/assertiv-gatsby-plugin-google-gtag'


export default class SectionOne extends React.Component {

    render() {
        return (
            <section className="container-fluid bg-xl-light-gray">
                <div className="row ml-0 mr-0">
                    <Wrapper className={"w-100 text-left"} gap="outer">
                        <div className="row bg-white justify-content-center pt-10">
                            <div className={"col-auto col-lg-10 m-lg-2 " + styles.contactParent}>
                                <TopTitle content="How can we help?" />
                                <div className={ styles.topTextBody + " col-12"}>
                                    <img alt="EngineID SSO Help" className={styles.tabletRightImage} src={HelpGraphic} />
                                    <p>
                                        EngineID solves this problem for you with Single Sign-On. Load all your applications into EngineID and give your staff a friendly, single pane of glass view with 
                                        everything they need at their fingertips.
                                    </p>
                                    <p>
                                        By logging into EngineID, staff can launch any application and not be prompted for a login again. One EngineID login accesses them all.
                                    </p>
                                    <p>
                                        Make your EngineID login stronger than a username and password by enabling Multi-Factor Authentication or even Passwordless login, <b>preventing 99.9% 
                                        of automated account attacks</b>.
                                    </p>
                                    <p>
                                        Not only does EngineID Single Sign-On improve security, it also enhances your user experience. Eliminating manual login saves time and actually makes 
                                        people happier.
                                    </p>
                                </div>
                            </div>
                            <div className={"col-auto col-lg-10 m-lg-2 pt-10 " + styles.contactParent}>
                                <TopTitle content="How it works?" />
                                <div className={ styles.topTextBody + " col-12"}>
                                    <div className={ "w-100" }>
                                        <p>
                                            To your users, Single Sign-On requires no extra effort. They log in and are immediately shown the applications they have permission to access. Clicking or tapping on an application 
                                            (it has a mobile friendly display too!) launches the application straight away. They are automatically logged in without having to provide a password.
                                        </p>
                                    </div>
                                    <div className={ "w-100" }>
                                        <video autoPlay muted loop controls className={ "w-100" }>
                                            <source src={SolutionVideo} type="video/mp4" />
                                        </video>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row bg-white justify-content-end pl-6 pr-6 pt-10">
                            <div className={"col-auto col-lg-5 m-lg-2 " + styles.contactParent}>
                                <TopTitle content="Why use EngineID?" />
                                <div className={styles.contactRow + " row bg-white"}>
                                    <div className={ styles.topTextBody + " col-12"}>
                                        <p>
                                            EngineID has been specializing in Identity and Authentication solutions since 2016. Our feature rich platform solves a wide range of complex challenges, with Single Sign On a core component of what we do.
                                        </p>
                                        <p>
                                            When you use EngineID, you receive many benefits:
                                        </p>
                                        <p>
                                            <ul>
                                                <li>An expert team of Identity and Authentication specialists and developers. Our focus is on solving complex challenges such as consolidation of diverse application landscapes.</li>
                                                <li>No additional servers required. Connect to our cloud hosted solution to use EngineID immediately.</li>
                                                <li>Ongoing support and enhancements of our solution. As a cloud product, we handle all patching and upgrades.</li>
                                                <li>Ongoing testing of our solution improves confidence of a secure solution.</li>
                                                <li>Highly scalable solution to cater for any number of users.</li>
                                                <li>EngineID is not limited to the App Launch Dashboard. There is a <OutboundLink href="../features">long list</OutboundLink> of included features you get at no additional cost.</li>
                                            </ul>
                                        </p>
                                        <p>
                                            Access Management is important to get right. Let EngineID up-lift your access strategy with confidence. In fact, we’re so confident in the EngineID product that we offer
                                            a <OutboundLink href="https://app.engineid.com/register">free plan</OutboundLink> that you can use right away.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className={"col-lg-6 " + styles.tabletParent}>
                                <div className={styles.tablet}>
                                    <img alt="EngineID OpenID Connect" className={styles.tabletImage} src={RiskGraphic} />
                                </div>
                            </div>
                        </div>
                    </Wrapper>
                </div>
            </section>
        );
    }
}